import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';


const EstatePlanRequestStepLayout = () => {
  const { onSubmit, saving } = useMetaLayoutContext();

  return (
    <FDBox>
      <MetaControlField attr={'imageUrl'} />
      <FDBox height={'20px'} />
      <TitleSection />
      <ActionsRow>
        <FDPrimaryActionButton label={'Continue'} onClick={onSubmit} loading={saving} disabled={saving} size={'lg'} isFullWidth />
      </ActionsRow>
      <FDBox padding={400}>
        <MetaControlField attr={'footer'} />
      </FDBox>
    </FDBox>
  );
};

EstatePlanRequestStepLayout.defaultProps = {
};

EstatePlanRequestStepLayout.propTypes = {
};

export default EstatePlanRequestStepLayout;
